RivalIQ.apps.Registration.module('models', function (models, App, Backbone, Marionette, $, _) {

    'use strict';

    models.LandscapeCompany = Backbone.Model.extend({
        url: '/api/company'
    });
});
